import React from 'react'
import { bool } from 'prop-types';
import LoadingImg from '../../Resources/Images/Loading/Loading.gif';

const Loading = (props) => {
  const {visible} = props;
  
  return (
    <>
        <div className={visible ? ("Loading Loading__show") : ("Loading Loading__hide")} >
            <img src={LoadingImg} alt="loading img"/>
        </div>
    </>
  )
}

Loading.propTypes = {
  visible: bool
};

Loading.defaultProps = {
  visible: false
};

export default Loading;
